/**
 * Authenticated admin query for read-only funnel-event delivery and activity.
 *
 * Aliases: admin funnel health, funnel reporting, event delivery health
 */

import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";

import { permissionMiddleware } from "~/lib/permission-middleware";

export const adminFunnelHealthQueryKeys = {
  report: ["admin-funnel-health", "report"] as const,
};

export const getAdminFunnelHealthReportFn = createServerFn({ method: "POST" })
  .middleware([permissionMiddleware("funnel-health:read")])
  .handler(async () => {
    const { getFunnelEventHealthReport } =
      await import("~/lib/server/funnel-event-health");
    return getFunnelEventHealthReport();
  });

export const adminFunnelHealthReportQueryOptions = queryOptions({
  queryKey: adminFunnelHealthQueryKeys.report,
  queryFn: () => getAdminFunnelHealthReportFn(),
});
